import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createVNode as _createVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/SignaturePlugin/A1/assets/download-csr-view.svg'


const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "row pt-5" }
const _hoisted_3 = { class: "col-12 col-lg-6" }
const _hoisted_4 = { class: "install-instructions-card px-4 py-4" }
const _hoisted_5 = { class: "info-footer d-flex align-items-center justify-content-center py-3 my-4" }
const _hoisted_6 = { class: "fs-6" }
const _hoisted_7 = ["href"]
const _hoisted_8 = { class: "py-3" }

import { useRouter } from 'vue-router'
  import Contact from '@/components/Molecules/Contact.vue'
  import Icon from '@/components/Atoms/Icon.vue'
  import { onBeforeMount, ref } from 'vue'
  import { usePlugin } from '@/store/Pinia/usePlugin.store'
  import { getOs, UserOperateSystem } from '@/utils/getOs'
  import sendClarityEvent from '@/utils/sendClarityEvent'

  
export default /*@__PURE__*/_defineComponent({
  __name: 'DigitalCertificateSuccesEmission',
  setup(__props) {

  const router = useRouter()
  const pluginStore = usePlugin()
  const csrDownloadLink = ref('')
  const os = getOs()

  function goToInstallInstructions() {
    sendClarityEvent('installInstructionsAccess')

    if (os.os === UserOperateSystem.LINUX) {
      window.open(
        'https://solutimanuais.gitbook.io/manual-de-emissao-e-instalacao-de-certificados-a1/instalacao-do-certificado-digital-a1/04-instalando-o-certificado-digital/instalacao-linux',
      )
      return
    }

    if (os.os === UserOperateSystem.WINDOWS) {
      window.open(
        'https://solutimanuais.gitbook.io/manual-de-emissao-e-instalacao-de-certificados-a1/instalacao-do-certificado-digital-a1/04-instalando-o-certificado-digital/instalacao-windows',
      )
      return
    }

    if (os.os === UserOperateSystem.MACOS) {
      window.open(
        'https://solutimanuais.gitbook.io/manual-de-emissao-e-instalacao-de-certificados-a1/instalacao-do-certificado-digital-a1/04-instalando-o-certificado-digital/instalacao-macos',
      )
      return
    }

    window.open(
      'https://solutimanuais.gitbook.io/manual-de-emissao-e-instalacao-de-certificados-a1/instalacao-do-certificado-digital-a1/04-instalando-o-certificado-digital',
    )
  }

  onBeforeMount(async () => {
    if (!pluginStore.csrDownloadLink.trim()) {
      router.replace({
        path: '/issue/plugin',
      })

      return
    }

    csrDownloadLink.value = pluginStore.csrDownloadLink
    pluginStore.clear()
  })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[4] || (_cache[4] = _createElementVNode("section", { class: "page-title-wrapper text-center pt-5" }, [
      _createElementVNode("h2", { class: "fw-600 pt-2" }, " Parabéns! Seu Certificado está pronto para instalação! ")
    ], -1)),
    _createElementVNode("section", _hoisted_2, [
      _cache[3] || (_cache[3] = _createElementVNode("div", { class: "col-md-6 d-none d-lg-block" }, [
        _createElementVNode("div", { class: "d-flex justify-content-end" }, [
          _createElementVNode("img", {
            class: "img-style mx-5",
            src: _imports_0,
            alt: "Imagem pessoa feliz"
          })
        ])
      ], -1)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _cache[1] || (_cache[1] = _createStaticVNode("<h3 class=\"install-instructions-card-title mb-4\" data-v-672037b2> Como instalar seu Certificado? </h3><div class=\"d-flex align-items-start mb-3\" data-v-672037b2><div class=\"purple-circle me-2\" data-v-672037b2><span data-v-672037b2>1</span></div><p class=\"text-start fs-6\" data-v-672037b2><strong data-v-672037b2>Encontre a pasta do Certificado</strong> no seu computador. </p></div><div class=\"d-flex align-items-start\" data-v-672037b2><div class=\"purple-circle me-2\" data-v-672037b2><span data-v-672037b2>2</span></div><p class=\"text-start fs-6\" data-v-672037b2><strong data-v-672037b2>Clique no botão abaixo</strong> e siga o passo a passo para instalação. </p></div>", 3)),
          _createElementVNode("div", null, [
            _createElementVNode("button", {
              class: "btn btn-primary",
              onClick: goToInstallInstructions
            }, [
              _createVNode(Icon, {
                name: "arrow-up-right-from-square",
                class: "me-2"
              }),
              _cache[0] || (_cache[0] = _createTextVNode(" Veja como instalar "))
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("span", _hoisted_6, [
            _cache[2] || (_cache[2] = _createTextVNode(" Não conseguiu baixar o Certificado? ")),
            _createElementVNode("a", {
              class: "link",
              href: csrDownloadLink.value,
              target: "_blank"
            }, " Clique aqui ", 8, _hoisted_7)
          ])
        ])
      ])
    ]),
    _createElementVNode("section", _hoisted_8, [
      _createVNode(Contact)
    ])
  ]))
}
}

})